<div class="row-grid">
  <div class="column-grid" [ngClass]="{ 'd-none': oneProject }">
    <div class="wrapper">
      <div class="project">
        <a [routerLink]="project.route + '/orders'" class="project-link">
          <app-project-view [iso]="project.isoCode"
            [name]="project.name" class="project-route">
          </app-project-view>
        </a>

        <div>
          <span class="debt-toggle-tooltip"
            matTooltip="{{ (debt?.monthCuts.length ? 'TABLE.show_debts' : 'TABLE.no_debts') | translate }}">
            <button (click)="visible = !visible" [color]="visible ? 'primary' : null"
              [disabled]="!debt?.monthCuts"
              mat-icon-button>
              <mat-icon>visibility</mat-icon>
            </button>
          </span>

          <button mat-icon-button [matMenuTriggerFor]="charts" color="primary">
            <mat-icon>bar_chart</mat-icon>
          </button>

          <mat-menu #charts>
            <a routerLink="{{project.route}}/analytic/{{project.id}}/debts"
              mat-menu-item>
              {{ 'DEBTS.chart' | translate }}
            </a>
            <a routerLink="{{project.route}}/analytic/{{project.id}}/claims"
              mat-menu-item>
              {{ 'DEBTS.claims_chart' | translate }}
            </a>
          </mat-menu>
        </div>
      </div>
    </div>

    @if (debt) {
      @for (data of debt.totalData; track data) {
        <div
          [style.gridColumnStart]="data.gridColumn">
          <app-heading
            subtitle="{{ data.totalCount }}  {{ 'TABLE.pcs' | translate }}"
            [title]="data.title">
          </app-heading>
        </div>
      }
    } @else {
      <h3 class="no-debts">{{ 'DEBTS.none' | translate }}</h3>
    }
  </div>

  @if (visible || oneProject) {
    <div @expandedPanel>
      @for (debt of debt.monthCuts; track trackById(i, debt); let i = $index) {
        <div class="column-grid table-wrapper">
          <div class="wrapper justify-center">
            <app-heading [subtitle]="$safeNavigationMigration(debt.sender?.name)" [title]="debt.courier.name"></app-heading>
          </div>
          @for (term of debt.debtsByMonth; track trackByIndex(j, term); let j = $index) {
            <div
              [style.gridColumnStart]="term.gridColumn">
              <app-heading subtitle="{{ term.totalCount }} {{ 'TABLE.pcs' | translate }}"
                [title]="term.title">
              </app-heading>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
